import type { FileUploadItemWeb } from '@gov-nx/core/hooks';

export const downloadAttachment = (attachment: FileUploadItemWeb) => {
	const url = URL.createObjectURL(attachment.file);
	const link = document.createElement('a');
	link.href = url;
	link.download = attachment.name;
	link.click();
	setTimeout(() => URL.revokeObjectURL(url), 0);
	link.remove();
};
